import React, { Component } from 'react';

import Item from './item'

class Record extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  onChange = (e) => {
    console.log(e);
  };

  render() {
    return (
      <>
        <table className="table table-striped table-thin border-bottom mt-4">
          <colgroup>
            <col width="70px"/>
            <col width="100px"/>
            <col width="100px"/>
            <col width="100px"/>
            <col width=""/>
            <col width=""/>
            <col width="200px"/>
          </colgroup>
          <thead>
            <tr>
              <th scope="col">NO</th>
              <th scope="col">작업유형</th>
              <th scope="col">작업자 ID</th>
              <th scope="col">작업자</th>
              <th scope="col">변경전 이력</th>
              <th scope="col">변경후 이력</th>
              <th scope="col">작업일시</th>
            </tr>
          </thead>
          <tbody>
            <Item />
          </tbody>
        </table>
      </>
    )
  }
}

export default Record;
